var _defs, _circle, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Info_Mark",
    "data-name": "Info Mark",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #ffa539;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n        font-size: 14px;\r\n        font-family: Roboto-Bold, Roboto;\r\n        font-weight: 700;\r\n      }\r\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_46",
    "data-name": "Ellipse 46",
    className: "cls-1",
    cx: 9,
    cy: 9,
    r: 9
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "i",
    className: "cls-2",
    transform: "translate(7 14)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "i"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoMark);
export default __webpack_public_path__ + "static/media/infoMark.94e5b88bf628d612cf5dbcfa929c594e.svg";
export { ForwardRef as ReactComponent };